import { dynamic, literal } from 'superstruct';
import { getFieldParentObject } from './getFieldParentObject';
import { withMessage } from './withMessage';
export const matchesField = (field, message) => dynamic((_value, {
  branch
}) => {
  const parent = getFieldParentObject(branch);
  const match = parent[field];
  const type = literal(match);
  if (message) {
    return withMessage(type, message);
  } else {
    return type;
  }
});